import { BaseService } from './base.service';
import { ConsentType, Consent } from '../types/consent';

class ConsentService extends BaseService {
  constructor() {
    super('/member-consents');
  }

  async getConsentByType(type: ConsentType): Promise<Consent> {
    return this.get<Consent>(`/consent/${type}`);
  }
}

export default new ConsentService();
